/* Description: Smooth progressive text animation
   Author: Sahil Ahlawat
   Updated On: Feb/24/25
   Created On: 12/13/24
   ========================================================================== */
   
// Select all quote elements
const quotes = document.querySelectorAll(".wp-block-quote p");

// Check if there are any quotes on the page
if (quotes.length > 0) {
  // Register GSAP ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  // Iterate over each quote element
  quotes.forEach((quote) => {
    // Wrap all words in span containers
    const words = quote.innerText.split(" ");
    if (words.length > 0) {
      quote.innerHTML = words
        .map(
          (word) =>
            `<span class="animatefrombottomcontainer"><span class="animatefrombottomtext">${word}</span></span>`
        )
        .join(" ");
    }

    const textElements = quote.querySelectorAll(".animatefrombottomtext");
    const totalWords = textElements.length;
    const divHeight = quote.scrollHeight + 20;

    // Create ScrollTrigger instance for each quote
    ScrollTrigger.create({
      trigger: quote,
      pin: false, // pin the trigger element while active
      start: "top bottom", // when the top of the trigger hits the bottom of the viewport
      scrub: 0.5, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
      end: "+=" + divHeight, // end after scrolling divheight beyond the start
      markers: false, // Adds markers that are helpful during development/troubleshooting
      onUpdate: (self) => {
        animateTextAppearance(self.progress, textElements, totalWords);
      },
    });
  });
}

// Function to animate words appearing progressively
function animateTextAppearance(progress, textElements, totalWords) {
  if (progress < 0 || !textElements) return;

  textElements.forEach((word, index) => {
    let wordStart = index / totalWords; // Define when each word starts
    let wordEnd = (index + 1) / totalWords; // Define when each word should be fully visible

    // Smooth interpolation: Words should animate in and settle as progress moves from 0 → 1
    let wordProgress = Math.min(1, Math.max(0, (progress - wordStart) / (wordEnd - wordStart)));

    let transformValue = 100 * (1 - wordProgress); // Smoothly move up from 100% → 0%
    
    word.style.transform = `translateY(${transformValue}%)`;
    word.style.opacity = wordProgress; // Gradual fade-in
  });
}
